import { render, staticRenderFns } from "./ratingItem.vue?vue&type=template&id=4f7fac66&scoped=true"
import script from "./ratingItem.vue?vue&type=script&lang=js"
export * from "./ratingItem.vue?vue&type=script&lang=js"
import style0 from "./ratingItem.vue?vue&type=style&index=0&id=4f7fac66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7fac66",
  null
  
)

export default component.exports